export default "__VITE_ASSET__DDJoxnIw__"